export default __webpack_public_path__ + "static/media/arrow-green-right.6c364306.svg";